<template>
  <fragment>
    <label>Upload Document: (Select files and then click on upload button to attach files.)</label>
    <el-upload
        class="multi-upload"
        action=""
        multiple
        :limit="5"
        :on-remove="handleRemove"
        :file-list="fileList"
        :auto-upload="false"
        :on-change="handleChange"
    >
      <el-button slot="trigger" size="small" type="primary">Select Files</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Upload</el-button>
      <div class="el-upload__tip">You can upload up to 5 files</div>
    </el-upload>
  </fragment>
</template>

<script>
import {File} from "@Views/Screening/utility/apiAgent";

export default {
  name: "MultiUpload",
  props: {
    uploadedFile: {
      type: Array
    },
    emailAddress: {
      type: String
    },
  },
  data() {
    {
      return {
        fileList: []
      }
    }
  },
  created() {
    this.$hub.$on('clear-uploaded-files', () => {
      this.fileList = [];
    });
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submitUpload() {
      const promises = [];
      this.fileList.forEach(file => {
        const data = {files: file.raw, type: 'CommentDocument', email: this.emailAddress};
        const formData = new FormData;
        for (const [key, value] of Object.entries(data)) {
          formData.append(key, value);
        }
        promises.push(File.uploadDocument(formData));
      });
      Promise.all(promises)
          .then((response) => {
            for (const responseElement of response) {
              this.uploadedFile.push({
                id: responseElement.data.data[0].id,
                name: responseElement.data.data[0].file_name,
                fileURL: responseElement.data.data[0].file_path,
              });
            }
            this.$toastr.s('Files uploaded successfully');
          });
    }
  }
}
</script>

<style scoped>
.multi-upload {
  display: flex;
  align-items: center;
}
</style>